import { ViewStyle } from 'react-native';

export const boxReturn: ViewStyle = {
  padding: 10,
  width: '100%',
  backgroundColor: 'rgb(255, 255, 255)',
  borderRadius: 10,
  marginBottom: 20,
};

export const stlBorder: ViewStyle = {
  alignItems: 'center',
  padding: 10,
  width: '100%',
  borderColor: '#666',
  borderWidth: 1,
  borderRadius: 10,
};

export const stlTag: ViewStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  padding: 10,
  width: '100%',
  backgroundColor: '#999',

  borderRadius: 10,
  flexDirection: 'row',
};

export const stlBtn1: ViewStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  padding: 10,
  minWidth: 80,
  backgroundColor: 'rgb(124, 35, 85)',
  borderRadius: 10,
};

export const stlBtn2: ViewStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  padding: 10,
  minWidth: 80,
  borderColor: 'rgb(124, 35, 85)',
  borderWidth: 2,
  borderRadius: 10,
};

export const stlBtnReturn: ViewStyle = {
  marginRight: 10,

  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 50,
  height: 26,
  width: 26,
};

export const stlError: ViewStyle = {
  borderColor: '#b0003a',
  borderWidth: 5,

  borderRadius: 17,
};
